import { render } from "./SuperAdminHelpPage.vue?vue&type=template&id=c8cc8f06"
import script from "./SuperAdminHelpPage.vue?vue&type=script&lang=js"
export * from "./SuperAdminHelpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__